export default __webpack_public_path__ + "static/media/placeholder.95b2a552.png";